export type SearchNamespace = 'default' | 'curatedList';

export const SEARCH_TYPE = {
    KEYWORD: 'keyword',
    SEMANTIC: 'semantic',
} as const;

export type SearchType = ValueOf<typeof SEARCH_TYPE>;

export const SIMILARITY = {
    SLIGHTLY_SIMILAR: 0.4,
    SIMILAR: 0.6,
    VERY_SIMILAR: 0.8,
    ALMOST_SAME: 0.9,
} as const;

export type SimilarityValue = ValueOf<typeof SIMILARITY>;
